<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.dkzg1">&nbsp; &nbsp; &nbsp;
        <img :src="images.dkzg2">
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">MULTI-ROLLING MILL FOR STEEL</span>
          </u>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        dkzg1: require("../../../assets/img/common/dkzg1.jpg"),
        dkzg2: require("../../../assets/img/common/dkzg2.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/dkzg.vue